export enum PlayerListType {
  Main,
  Unrated,
}
